module.exports = __webpack_public_path__ + "static/media/landingBack.fd66249d.svg";